export function isPluginEventName(eventName) {
  if (!eventName) {
    return false;
  }
  var eventSegments = eventName.split(':');
  return eventSegments.length > 1 && eventSegments[0].length > 0;
}